import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { ToggleButtonReuseTwo } from "../../AllButton/ToggleButtonReuse";
import { Button, Image } from "react-bootstrap";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import MassCompletion from "../../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MassCompletion";

export const CasualDiningEditEventManagement = (props) => {
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === "view"
      ? true
      : false
  );
  const history = useHistory();
  const [state, setState] = useState({
    casualDiningOfflineEvent: false,
    casualDiningOnlineEvent: false,
    massCompletion: false,
    massCompletionTime: "",
    actionButton: false,
  });

  const onClickCasualOfflineEvent = (e) => {
    if (state.casualDiningOfflineEvent === true) {
      setState({
        ...state,
        casualDiningOfflineEvent: !state.casualDiningOfflineEvent,
        actionButton: true,
      });
    } else {
      history.push("/edit-event-subscription/edit-event-offline-subscription");
    }
  };

  const onClickCasualOnlineEvent = (e) => {
    if (state.casualDiningOnlineEvent === true) {
      setState({
        ...state,
        casualDiningOnlineEvent: !state.casualDiningOnlineEvent,
        actionButton: true,
      });
    } else {
      history.push("/edit-event-subscription/edit-event-online-subscription");
    }
  };

  const massCompletionToggle = (e) => {
    setState({
      ...state,
      massCompletion: !state.massCompletion,
    });
  };

  const onChangeMassCompletion = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onCasualOnlineEventSubmitClick = () => {
    let values = {
      // value:
      //   state.casualDiningOfflineEvent === false &&
      //   state.casualDiningOnlineEvent === false
      //     ? false
      //     : true,
      value: true,
      offline_event: {
        value: state.casualDiningOfflineEvent,
      },
      online_event: {
        value: state.casualDiningOnlineEvent,
      },
      massCompletion: {
        value: state.massCompletion,
        massCompletionTime: state.massCompletionTime,
      },
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    if (props?.casualDiningService) {
      formData.casual_dining_status.event_management.value = values.value;
      formData.casual_dining_status.event_management.offline_event.value =
        values.offline_event.value;
      formData.casual_dining_status.event_management.online_event.value =
        values.online_event.value;
      formData.casual_dining_status.event_management.massCompletion.value =
        values?.massCompletion?.value;
      formData.casual_dining_status.event_management.massCompletion.massCompletionTime =
        values?.massCompletion?.massCompletionTime;
    } else if (props?.multiDiningService) {
      formData.multi_service_business_status.event_management.value =
        values.value;
      formData.multi_service_business_status.event_management.offline_event.value =
        values.offline_event.value;
      formData.multi_service_business_status.event_management.online_event.value =
        values.online_event.value;
      formData.multi_service_business_status.event_management.massCompletion.value =
        values?.massCompletion?.value;
      formData.multi_service_business_status.event_management.massCompletion.massCompletionTime =
        values?.massCompletion?.massCompletionTime;
    }
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Event Edited Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/profile");
  };

  useEffect(() => {
    setState({
      ...state,
      casualDiningOfflineEvent:
        props.subscriptionData &&
        props.subscriptionData.offline_event &&
        props.subscriptionData.offline_event.value !== undefined
          ? props.subscriptionData &&
            props.subscriptionData.offline_event &&
            props.subscriptionData.offline_event.value
          : false,
      casualDiningOnlineEvent:
        props.subscriptionData &&
        props.subscriptionData.online_event &&
        props.subscriptionData.online_event.value !== undefined
          ? props.subscriptionData &&
            props.subscriptionData.online_event &&
            props.subscriptionData.online_event.value
          : false,
      massCompletion:
        props?.subscriptionData?.massCompletion?.value !== null &&
        props?.subscriptionData?.massCompletion?.value !== undefined
          ? props?.subscriptionData?.massCompletion?.value
          : false,
      massCompletionTime:
        props?.subscriptionData?.massCompletion?.massCompletionTime !== null &&
        props?.subscriptionData?.massCompletion?.massCompletionTime !==
          undefined
          ? props?.subscriptionData?.massCompletion?.massCompletionTime
          : "",
    });
  }, [props.subscriptionData]);

  const [editButton, setEditButton] = useState(false);
  const onEditClickChange = (e) => {
    setEditButton(!editButton);
  };

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-md-8 col-12 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className=" p-0">
                  <div className="mb-4">
                    <TopTextReusableComponent
                      headingText="Event Management"
                      // displayEdit={editButton}
                      // onClickEdit={onEditClickChange}
                    />
                  </div>
                  <div className="f16-700 my-4">Activate Event Types</div>
                  <div className="row">
                    <div className="col-7">
                      <ToggleButtonReuseTwo
                        mainText="Offline Events"
                        paragraphText="(Note: Events are in a physical venue and you can even accept RSVP)"
                        checkedBox={state.casualDiningOfflineEvent}
                        onChange={
                          // editButton ?
                          onClickCasualOfflineEvent
                          //  : () => {}
                        }
                        // disabled={editButton ? false : true}
                        extraClass="d-flex align-items-center"
                      />
                    </div>
                    <div className="col-5">
                      <div
                        className="d-flex rightside-toggle-buttons-subscription-menu"
                        // style={{ minWidth: "150px", marginLeft: "25px" }}
                      >
                        {/* {checkedBox && ( */}
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={(e) => {
                              history.push({
                                pathname:
                                  "/edit-event-subscription/edit-event-offline-subscription",
                                state: { access: "view" },
                              });
                            }}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={(e) => {
                              history.push({
                                pathname:
                                  "/edit-event-subscription/edit-event-offline-subscription",
                                state: { access: "edit" },
                              });
                            }}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                  <hr className="mt-5 mb-5" />
                  <div className="row">
                    <div className="col-7">
                      <ToggleButtonReuseTwo
                        mainText="Online Events"
                        paragraphText="(Note: Events are online you need a link stored at the time Event creation You can accept RSVP for the event)"
                        checkedBox={state.casualDiningOnlineEvent}
                        onChange={
                          // editButton ?
                          onClickCasualOnlineEvent
                          //  : () => {}
                        }
                        // disabled={editButton ? false : true}
                        extraClass="d-flex align-items-center"
                      />
                    </div>
                    <div className="col-5">
                      <div
                        className="d-flex rightside-toggle-buttons-subscription-menu"
                        // style={{ minWidth: "150px", marginLeft: "25px" }}
                      >
                        {/* {checkedBox && ( */}
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={(e) => {
                              history.push({
                                pathname:
                                  "/edit-event-subscription/edit-event-online-subscription",
                                state: { access: "view" },
                              });
                            }}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={(e) => {
                              history.push({
                                pathname:
                                  "/edit-event-subscription/edit-event-online-subscription",
                                state: { access: "edit" },
                              });
                            }}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <MassCompletion
                        MassCompletionToggle={(e) => massCompletionToggle()}
                        massCompletionValue={state.massCompletion}
                        handleChange={(e) => onChangeMassCompletion(e)}
                        massCompletionTime={state.massCompletionTime}
                      />
                    </div>
                  </div>
                  <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                    <ReusableOnboardingLink
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      link="/profile"
                    />
                    {!disabled ? (
                      // && editButton
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass={
                          // state.actionButton
                          //   ?
                          "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                          // : "onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
                        }
                        buttonText="Done"
                        buttonType="button"
                        onClick={
                          // state.actionButton
                          //   ?
                          onCasualOnlineEventSubmitClick
                          // : () => {}
                        }
                        // disabled={disabled}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="bottom-panel">
              <BottomNavigationMobile />
            </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
};

CasualDiningEditEventManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  /************* Active Service ************/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  // fastFoodDiningService:
  //   state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  /************* Subscription Data ************/
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.event_management
      : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.event_management,
  /************* All SubscriptionsData Data ************/
  allSubscriptionsData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(CasualDiningEditEventManagement));
